import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { surveysService } from "../services/surveys";
import { useAuthStore } from "../store/authStore";

export default function SurveysPage() {
  const { user } = useAuthStore();

  const { data, isLoading, error } = useQuery({
    queryKey: ["surveys", "active"],
    queryFn: () => surveysService.list({ status: "active" }),
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-gray-400">Loading surveys...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <p className="text-red-400">Error loading surveys: {(error as Error).message}</p>
      </div>
    );
  }

  const surveys = data?.surveys || [];

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-100">Surveys</h1>
        {user?.role === "question_owner" && (
          <Link to="/surveys/create" className="btn btn-primary">
            Create Survey
          </Link>
        )}
      </div>

      {surveys.length === 0 ? (
        <div className="card text-center py-12">
          <p className="text-gray-400 mb-4">No surveys available yet.</p>
          {user?.role === "question_owner" && (
            <Link to="/surveys/create" className="btn btn-primary">
              Create Your First Survey
            </Link>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {surveys.map((survey) => (
            <Link
              key={survey.id}
              to={`/surveys/${survey.id}`}
              className="card hover:border-primary-500 transition-all"
            >
              <h3 className="text-xl font-bold text-gray-100 mb-2">{survey.title}</h3>
              {survey.description && (
                <p className="text-gray-400 mb-4 line-clamp-2">{survey.description}</p>
              )}
              <div className="space-y-2 text-sm text-gray-500">
                <p>Status: <span className="font-medium capitalize text-gray-300">{survey.status}</span></p>
                <p>Budget: <span className="font-medium text-gray-300">{survey.budget} coins</span></p>
                <p>Responses: <span className="font-medium text-gray-300">{survey.actual_responses} / {survey.target_responses}</span></p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
